// extracted by mini-css-extract-plugin
export default {"form-group":"RightSidebar_form-group__2Qh-y","container":"RightSidebar_container__UPg90","containerWithHeader":"RightSidebar_containerWithHeader__a9BA1"};